import Tasks from 'APP/Tasks';
import { ScheduleSettingsPopup } from 'APP/main/PopupManager/Popups/ScheduleSettingsPopup/ScheduleSettingsPopup';
import Entities from 'STORE';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export function createScheduledArticle(groupId: string, payload: ArticlePayload): void {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const canSend = Tasks.messaging.canSendMessage({ groupId, isCheckSlowMode: false, payload });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return;
  }

  Tasks.app.openPopup(ScheduleSettingsPopup, {
    params: {
      onSubmit: async (date) => {
        const result = await Tasks.messaging.createScheduledMessage(groupId, {
          payload,
          scheduleTime: date.getTime(),
        });

        if (result) {
          Tasks.group.setActiveGroup({ groupId: group.scheduleGroupId });
        }
      },
    },
  });
}
